module.exports = __webpack_public_path__ + "static/media/insight.b72e1f9c.svg";